/** Drifts: the tradeoff you pick for the next run at each Fold (GDD §5.5). */

import { ORES, type FleetStat } from './resources';

export interface DriftDef {
  readonly id: string;
  readonly name: string;
  readonly upside: string;
  readonly downside: string;
  readonly color: string;
  /** Additive fleet-stat changes (negative is a penalty). */
  readonly stats?: Partial<Record<FleetStat, number>>;
  /** Multiplier on the base value of specific ores. */
  readonly oreValue?: Readonly<Record<string, number>>;
  /** Multiplier on crafted item value. */
  readonly itemValue?: number;
  /** Mining multiplier by planet index range [from, to] inclusive. */
  readonly planetMine?: readonly { readonly from: number; readonly to: number; readonly mult: number }[];
  /** Multiplier on TE at the next Fold. */
  readonly teMult?: number;
}

export const DRIFTS: readonly DriftDef[] = [
  { id: 'calm', name: 'Calm Drift', color: '#4ee08a', upside: 'Planets 25% cheaper', downside: 'TE −15%', stats: { discount: 0.25 }, teMult: 0.85 },
  { id: 'cryo', name: 'Cryo Drift', color: '#7fe6ff', upside: 'Silica and Cryonite ×2 value', downside: 'Ship speed −10%', oreValue: { silica: 2, cryonite: 2 }, stats: { ship: -0.1 } },
  { id: 'ember', name: 'Ember Drift', color: '#ff7a3d', upside: 'Smelting ×1.5 speed', downside: 'Selling raw ore −30%', stats: { smelt: 0.5 }, oreValue: Object.fromEntries(ORES.map((ore) => [ore.id, 0.7])) },
  { id: 'rift', name: 'Rift Drift', color: '#ff3d7f', upside: 'TE +50% at the next Fold', downside: 'Planets 40% dearer', teMult: 1.5, stats: { discount: -0.4 } },
  { id: 'prism', name: 'Prism Drift', color: '#ff7aab', upside: 'Crafted items +30% value', downside: 'Mining −10%', itemValue: 1.3, stats: { mine: -0.1 } },
  { id: 'forge', name: 'Forge Drift', color: '#f5c542', upside: 'Smelt and craft yield +25%', downside: 'Cargo −20%', stats: { smeltYield: 0.25, craftYield: 0.25, cargo: -0.2 } },
  { id: 'deep', name: 'Deep Drift', color: '#9b7bff', upside: 'Planets 7–12 mine ×2', downside: 'Planets 1–4 mine ×0.5', planetMine: [{ from: 6, to: 11, mult: 2 }, { from: 0, to: 3, mult: 0.5 }] },
];

export function driftDef(id: string | null): DriftDef | null {
  if (!id) return null;
  return DRIFTS.find((d) => d.id === id) ?? null;
}
